import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminReferenceFT(props) {
    const formRef = useRef(null)

    const [datalist, setDatalist] = useState([]);
    const [dataitem, setDataitem] = useState({
        year: 0,
        m1: 0,
        m2: 0,
        m3: 0,
        m4: 0,
        m5: 0,
        m6: 0,
        m7: 0,
        m8: 0,
        m9: 0,
        m10: 0,
        m11: 0,
        m12: 0,
        month: "m1"
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_item, setModal_item] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function init_item() {
        setDataitem({
            year: 0,
            m1: 0,
            m2: 0,
            m3: 0,
            m4: 0,
            m5: 0,
            m6: 0,
            m7: 0,
            m8: 0,
            m9: 0,
            m10: 0,
            m11: 0,
            m12: 0,
            month: "m1"
        })
    }

    useEffect(() => {
        api_load()
        return () => {
            setDatalist([])
            setDataitem({})
        };
    }, []);

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading FT charge list." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refft/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {

                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.ft !== null && response.data.ft !== undefined) {
                    setDatalist(response.data.ft)
                } else {
                    setDatalist([])
                }
            })
            .catch((err) => {
                setDatalist([])
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_edit() {
        var formelement = formRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");

            setmodal_load({ enable: true, message: "Editing an FT charge in a database." })
            await sleep(500)

            const formData = new FormData();
            formData.append('ft_val', dataitem[dataitem.month])
            formData.append('year', dataitem.year)
            formData.append('month', dataitem.month)
            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refft/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_item(false)
                    init_item()
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your FT charge has been edited in a database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.ft !== null && response.data.ft !== undefined) {
                        setDatalist(response.data.ft)
                    } else {
                        setDatalist([])
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-calendar-alt"></i> FT Charge</h4>
                                    <p className="mb-0">Manage all parameter of fuel adjustment charge</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>FT Charge Table</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>Year</th>
                                        <th>January</th>
                                        <th>February</th>
                                        <th>March</th>
                                        <th>April</th>
                                        <th>May</th>
                                        <th>June</th>
                                        <th>July</th>
                                        <th>August</th>
                                        <th>September</th>
                                        <th>October</th>
                                        <th>November</th>
                                        <th>December</th>
                                        <th>Edit Time</th>
                                        {
                                            props.permitdata !== undefined ?
                                                props.permitdata.user_role === "Admin" ?
                                                    <th className="text-center action-fixwidth" style={{ width: "100px" }}>Action</th>
                                                    :
                                                    null
                                                : null
                                        }
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        datalist?.map((data, index) => (
                                            <tr key={data.year}>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {data.year}</td>
                                                <td>{data.m1 > 0 ? data.m1.toFixed(4) : "-"}</td>
                                                <td>{data.m2 > 0 ? data.m2.toFixed(4) : "-"}</td>
                                                <td>{data.m3 > 0 ? data.m3.toFixed(4) : "-"}</td>
                                                <td>{data.m4 > 0 ? data.m4.toFixed(4) : "-"}</td>
                                                <td>{data.m5 > 0 ? data.m5.toFixed(4) : "-"}</td>
                                                <td>{data.m6 > 0 ? data.m6.toFixed(4) : "-"}</td>
                                                <td>{data.m7 > 0 ? data.m7.toFixed(4) : "-"}</td>
                                                <td>{data.m8 > 0 ? data.m8.toFixed(4) : "-"}</td>
                                                <td>{data.m9 > 0 ? data.m9.toFixed(4) : "-"}</td>
                                                <td>{data.m10 > 0 ? data.m10.toFixed(4) : "-"}</td>
                                                <td>{data.m11 > 0 ? data.m11.toFixed(4) : "-"}</td>
                                                <td>{data.m12 > 0 ? data.m12.toFixed(4) : "-"}</td>
                                                <td>{data.edittime !== "-" ? data.edittime : "-"}</td>
                                                {
                                                    props.permitdata !== undefined ?
                                                        props.permitdata.user_role === "Admin" && data.m1 > 0 ?
                                                            <td>
                                                                <Link className="btn btn-icon btn-sm btn-success btn-hover btn-bordered" title="Edit"
                                                                    onClick={() => {
                                                                        setDataitem({
                                                                            year: data.year,
                                                                            m1: data.m1,
                                                                            m2: data.m2,
                                                                            m3: data.m3,
                                                                            m4: data.m4,
                                                                            m5: data.m5,
                                                                            m6: data.m6,
                                                                            m7: data.m7,
                                                                            m8: data.m8,
                                                                            m9: data.m9,
                                                                            m10: data.m10,
                                                                            m11: data.m11,
                                                                            m12: data.m12,
                                                                            month: "m1"
                                                                        })
                                                                        setModal_item(true)
                                                                    }}
                                                                ><i className="fas fa-pen"></i></Link>
                                                            </td>
                                                            :
                                                            <td><div style={{ height: "25px" }}>-</div></td>
                                                        : null
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                    {
                        modal_item ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-md modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-calendar-alt"></i> Edit FT Charge</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_item(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row mb-3">
                                                        <div className="col-md-8">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="year">Year (YYYY)</label>
                                                                <input type="text" className="form-control" name="year" value={dataitem.year} required readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-8">
                                                            <div className="form-group">
                                                                <label htmlFor="month">FT Period</label>
                                                                <select name="month" className="form-select mb-3" value={dataitem.month} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        month: e.target.value
                                                                    })
                                                                }} required>
                                                                    <option value="">Please select</option>
                                                                    <option value={'m1'}>January - April</option>
                                                                    <option value={'m5'}>May - August</option>
                                                                    <option value={'m9'}>September - December</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-8">
                                                            <div className="form-group">
                                                                <label htmlFor="ft_val">FT Value (Bath/kWh)</label>
                                                                <input type="number" className="form-control" name="ft_val" min={0.0001} max={20} step={0.0001} value={dataitem[dataitem.month]} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        [dataitem.month]: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_item(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_edit() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminReferenceFT